import React from 'react'
import { useHelpOverlay } from '@fs/zion-help-overlay'
import { NoticeQuestion } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import HeaderIconButton from '../../../shared/components/HeaderIconButton'

export default function HeaderHelpButton({ linkName }) {
  const { handleClick } = useHelpOverlay(window?.location?.href)
  const { t } = useTranslation()
  return (
    <HeaderIconButton
      title={t('nav.help', 'Help')}
      linkName={linkName}
      data-selector="helpOverlayButton"
      Icon={NoticeQuestion}
      onClick={handleClick}
    />
  )
}
